module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "maximizing-leadership-potential-right.a6dc9e22.webp" + "?" + Date.now();